import React, { useEffect, useState } from 'react'

const ScrollTopButton = () => {
  const [active, setActive] = useState(false)

  useEffect(() => {
    const toggleScrollTop = () => {
      setActive(window.scrollY > 100)
    }
    window.addEventListener('load', toggleScrollTop)
    window.addEventListener('scroll', toggleScrollTop)
    return () => {
      window.removeEventListener('load', toggleScrollTop)
      window.removeEventListener('scroll', toggleScrollTop)
    }
  }, [])

  const handleClick = (e) => {
    e.preventDefault()
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return (
    <a
      href="#"
      className={`scroll-top d-flex align-items-center justify-content-center ${active ? 'active' : ''}`}
      onClick={handleClick}
      aria-label="Scroll to top"
    >
      <i className="bi bi-arrow-up-short" />
    </a>
  )
}

export default ScrollTopButton
